const style = (theme): any => ({
    bigAvatar: {},
    formInput: {},
    partnerInfo: {},
    partnerInfoLabel: {
        color: theme.palette.secondary.light,
    },
    card: {
        '& .MuiCardContent-root': {
            paddingBottom: 0,
        },
    },
    rightActions: {
        justifyContent: 'flex-end',
    },
    table: {},
    pointsSummary: {
        display: 'flex',
        gap: 24,
        marginBottom: 8,
    },
    pointsGained: {
        color: theme.palette.success.main,
    },
    pointsSpent: {
        color: theme.palette.danger.main,
    },
    pointsMore: {
        display: 'flex',
        justifyContent: 'center',
    },
});
export default style;
